export default __webpack_public_path__ + "static/tilea-1761e01aab8ae969b83f9dc2d1247661.webp";